import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Translate } from 'core/translate';
import { Button, ButtonIcon, ButtonText } from 'core/controls';

const FINANCE = 'finance';
const LEASE = 'lease';

const computeActiveTab = (showFinance, showLease) => {
  if (!showFinance && !showLease) {
    return '';
  }

  if (!showFinance && showLease) {
    return 'lease';
  }

  return 'finance';
};

const FinancingHeader = ({
  header,
  visible,
  anaytlicsKey,
  isActive,
  onClick
}) => {
  if (!visible) {
    return null;
  }

  return (
    <div
      className="finance-options__header stat-text-link"
      data-dtm={anaytlicsKey}
      onClick={onClick}>
      <button
        className={`finance-options__header-content ${
          isActive ? 'finance-options__header-content--active' : ''
        }`}>
        <Translate value={header} />
      </button>
    </div>
  );
};

const FinanceOptionsTabs = ({ activeTab, onClick, showFinance, showLease }) => {
  return (
    <div className="finance-options__tabs">
      <FinancingHeader
        header={'component.pricing.finance.header'}
        visible={showFinance}
        isActive={activeTab === FINANCE}
        onClick={() => onClick(FINANCE)}
        anaytlicsKey={FINANCE}
      />
      <FinancingHeader
        header={'component.pricing.lease.header'}
        visible={showLease}
        onClick={() => onClick(LEASE)}
        isActive={activeTab === LEASE}
        anaytlicsKey={LEASE}
      />
    </div>
  );
};

const FinanceContent = ({ activeTab }) => {
  return (
    <Fragment>
      <div
        style={{ display: `${activeTab === FINANCE ? 'block' : 'none'}` }}
        className="finance-options__content">
        <div className="finance-options__content-finance">
          <gmst-pe-finance-summary />
          <div>
            <Button
              as={Link}
              analytics="text"
              to="/summary/payment"
              className="button--flex button--link button--summary-link button--without-padding"
              data-dtm="adjust payments finance">
              <ButtonIcon name="pencil" />
              <ButtonText>
                <Translate value="component.pricing.estimate.payments" />
              </ButtonText>
            </Button>
          </div>
        </div>
      </div>
      <div
        style={{ display: `${activeTab === LEASE ? 'block' : 'none'}` }}
        className="finance-options__content">
        <div className="finance-options__content-lease">
          <gmst-pe-lease-summary />
          <div>
            <Button
              as={Link}
              analytics="text"
              to="/summary/payment?initialTab=lease"
              className="button--flex button--link button--summary-link button--without-padding"
              data-dtm="adjust payments lease">
              <ButtonIcon name="pencil" />
              <ButtonText>
                <Translate value="component.pricing.estimate.payments" />
              </ButtonText>
            </Button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

class SummaryFinanceContent extends Component {
  constructor(props) {
    super(props);

    const { showFinance, showLease } = this.props;

    this.state = {
      activeTab: computeActiveTab(showFinance, showLease)
    };
  }

  onClick = type => {
    this.setState({ activeTab: type });
  };

  componentDidUpdate(prevProps) {
    const { showFinance, showLease } = this.props;

    if (
      showFinance !== prevProps.showFinance ||
      showLease !== prevProps.showLease
    ) {
      this.setState({
        activeTab: computeActiveTab(showFinance, showLease)
      });
    }
  }

  render() {
    const { showFinance, showLease } = this.props;
    const activeTab = this.state.activeTab;

    return (
      <div
        id="financing-options"
        className="finance-options__container summary__financing-options">
        <div className="finance-options__container">
          <FinanceOptionsTabs
            activeTab={activeTab}
            onClick={this.onClick}
            showFinance={showFinance}
            showLease={showLease}
          />
          <FinanceContent activeTab={activeTab} />
        </div>
      </div>
    );
  }
}

export default SummaryFinanceContent;
